import React from 'react';
import classNames from 'classnames';
import { SuggestedActionType } from 'router/subrouters/DataRoom/models/Dashboard';
import { ACTIVE_SUGGESTION_ICON, COLOR_SUGGESTION_ICON } from '../../data';

import './SuggestedActionIcon.styles.scss';

type SuggestedActionIconProps = {
  className?: string;
  type: SuggestedActionType;
};

const SuggestedActionIcon: React.FC<SuggestedActionIconProps> = (props) => {
  const { className, type } = props;

  const Icon = ACTIVE_SUGGESTION_ICON[type];
  const color = COLOR_SUGGESTION_ICON[type];

  const classes = classNames('suggested-action-icon', color, className);

  return (
    <span className={classes}>
      <Icon />
    </span>
  );
};

export default SuggestedActionIcon;
